import { rechargeApiRequest } from '../utils/request.js';
async function productSearch(session, query) {
  if (!["2020-12", "2022-06"].includes(query.format_version)) {
    throw new Error("Missing or unsupported format_version.");
  }
  return rechargeApiRequest("get", `/product_search`, {
    query,
    headers: {
      "X-Recharge-Version": "2021-01"
    }
  }, session);
}
export { productSearch };